<div class="modal-content">
  <div class="modal-header bg-primary-100">
    <h5 class="modal-title">{{ isRejection ? 'Reject Request' : 'Verify Request' }}</h5>
  </div>
  <div class="modal-body">
    @if (!isRejection) {
      <p>Select the professional development type for this verification.</p>
      <label for="professionalDevelopmentTypeCodeId" class="form-label">Professional Development Type</label>
      <ng-select
        id="professionalDevelopmentTypeCodeId"
        name="professionalDevelopmentTypeCodeId"
        [closeOnSelect]="true"
        [multiple]="false"
        [(ngModel)]="selectedProfessionalDevelopmentTypeCodeId"
        placeholder="Select a type..."
      >
        @for (option of professionalDevelopmentTypeOptions; track option.id) {
          <ng-option [value]="option.id">{{ option.description }}</ng-option>
        }
      </ng-select>
    }
    @if (isRejection) {
      <p>Please provide the reason for rejecting this request.</p>
      <label for="rejectionDetails" class="form-label">Rejection Details</label>
      <textarea
        id="rejectionDetails"
        name="rejectionDetails"
        rows="4"
        class="form-control"
        [(ngModel)]="rejectionDetails"
        placeholder="Enter rejection details..."
      ></textarea>

      @if (rejectionDetails) {
        <div class="mt-2">Markdown Preview:</div>
        <div markdown [data]="rejectionDetails"></div>
      }
    }
  </div>
  <div class="modal-footer d-flex">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="confirm()"
      [disabled]="(!isRejection && !selectedProfessionalDevelopmentTypeCodeId) || (isRejection && !rejectionDetails)"
    >
      {{ isRejection ? 'Reject' : 'Verify' }}
    </button>
  </div>
</div>
